import { BrandConfig } from './types';

export const leverupBrand: BrandConfig = {
  id: 'leverup',
  hosts: ['app.leverup.xyz', 'localhost', '127.0.0.1'],
  title: 'LeverUp',
  siteName: 'LeverUp',
  description:
    'LeverUp is an LP-Free perpetuals exchange delivering uncapped open interest, 100% fee redistribution to traders, and leverage up to 1001x',
  canonicalOrigin: 'https://app.leverup.xyz',
  twitterSite: '@LeverUp_xyz',
  logoSrc: '/images/logo.svg',
  faviconHref: '/favicon-v2.ico',
  previewImageUrl: 'https://app.leverup.xyz/images/leverup_preview_tiny.png',
  navItems: [
    'trade',
    'LVUSD',
    'LVMON',
    'fairlaunch',
    'airdrop',
    'competition',
    'portfolio',
    'leaderboard',
  ],
  collateralTokenSymbols: ['USDC', 'MON', 'LVUSD', 'LVMON', 'LV', 'EMO'],
  theme: {
    primary: '#C7F50D',
    navBg: '#131613',
    pageBg: '#0f110f',
    activeNav: '#C7F50D',
  },
};